/**
 * Shared: функционал копирования SKU товара.
 *
 * Используется блоками product-card и product-crosssell.
 */

const TOOLTIP_COPY = 'Скопировать артикул';
const TOOLTIP_COPIED = 'Скопировано';
const COPIED_RESET_MS = 2500;

function showCopiedFeedback(button) {
	const prevTitle = button.getAttribute('title');
	button.setAttribute('title', TOOLTIP_COPIED);

	setTimeout(() => {
		button.setAttribute('title', prevTitle || TOOLTIP_COPY);
	}, COPIED_RESET_MS);
}

function copyFallback(button, value) {
	const textarea = document.createElement('textarea');
	textarea.value = value;
	textarea.setAttribute('readonly', '');
	textarea.style.position = 'absolute';
	textarea.style.left = '-9999px';
	document.body.appendChild(textarea);
	textarea.select();

	try {
		document.execCommand('copy');
		showCopiedFeedback(button);
	} catch (e) {
		// Fallback failed silently
	}

	document.body.removeChild(textarea);
}

function copySku(button) {
	const sku = button.dataset.sku || '';
	if (!sku) {
		return;
	}

	if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(sku).then(
			() => showCopiedFeedback(button),
			() => copyFallback(button, sku)
		);
		return;
	}

	copyFallback(button, sku);
}

/**
 * Инициализировать обработчик копирования SKU.
 *
 * @param {string} selector CSS селектор кнопки копирования.
 */
export function initCopySkuHandler(selector = '.wps-product-card__copy') {
	document.addEventListener('click', (event) => {
		const button = event.target.closest(selector);
		if (!button) {
			return;
		}

		event.preventDefault();
		copySku(button);
	});
}

export default initCopySkuHandler;
